import { companyService } from '../../services/company.service'

// initial state
const state = () => ({
  companies: [],
  company: null
})

// actions
const actions = {
  getCompanies({ commit }, eventId) {
    companyService.getCompanies(eventId).then(
      (companies) => {
        commit('getCompaniesSuccess', companies)
      },
      (error) => {
        commit('getCompaniesFailure', error)
      }
    )
  },
  getCompany({ commit }, companyId) {
    companyService.getCompany(companyId).then(
      (company) => {
        commit('getCompanySuccess', company)
      },
      (error) => {
        commit('getCompanyFailure', error)
      }
    )
  },
  createCompany({ commit }, companyData) {
    companyService.createCompany(companyData).then(
      (company) => {
        commit('getCompanySuccess', company[0])
      },
      (error) => {
        commit('getCompanyFailure', error)
      }
    )
  },
  updateCompany({ commit }, { companyId, companyData }) {
    companyService.updateCompany(companyId, companyData).then(
      (company) => {
        commit('getCompanySuccess', company[0])
      },
      (error) => {
        commit('getCompanyFailure', error)
      }
    )
  },
  deleteCompany({ commit }, companyId) {
    companyService.deleteCompany(companyId).then(
      (company) => {
        commit('getCompanySuccess', company)
      },
      (error) => {
        commit('getCompanyFailure', error)
      }
    )
  }
}

// mutations
const mutations = {
  getCompaniesSuccess(state, companies) {
    state.companies = companies
  },
  getCompanySuccess(state, company) {
    state.company = company
  },
  getCompaniesFailure(state, error) {
    console.log(state, error)
  },
  getCompanyFailure(state, error) {
    console.log(state, error)
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
